import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-monthwise-website-enq-report',
  templateUrl: 'monthwise-website-enq-report.html',
})
export class MonthwiseWebsiteEnqReportPage {

  MonthReport: any;

  School = 'All';
  SchoolData = {};

  hide = 0;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.loadvalues(this.SchoolData[this.School]);

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MonthwiseProgressReportPage');
  }

  active_tab(tab) {
    this.hide = 0;
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School]);
  }

  loadvalues(schoolId) {

    this.hide = 0;

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.MonthReport = [];

    this.service.httpcall('app_web_service/get_progress_monthwise_website_enq_form_report?schoolId='+schoolId).subscribe(data => {

      this.MonthReport = data;
      // this.AllSorceData = data['Data']['Sub_ststus'];
      console.log('MonthReport',this.MonthReport);
      this.hide = 1;
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School]);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/monthwise-website-enq-report/monthwise-website-enq-report.ts